import React from 'react';
import Parser from 'react-html-parser';
import Grow from '@material-ui/core/Grow';
import VerticalAlignTopRounded from '@material-ui/icons/VerticalAlignTopRounded';

import styles from './styles';
import { logPageView } from '../../../services/Analytics';
import Component from '../../../ui-components/Component';
import SimpleHeader from '../../../ui-components/Header/Simple';
import Footer from '../../../ui-components/Footer';
import { guc } from '../../../services/Localisation';
import { isEmptyList, isEmptyObject, merge, notIsEmptyString } from '../../../utils';
import { Carousel } from 'react-responsive-carousel';
import ButtonBase from '@material-ui/core/ButtonBase';
import { getCtaLinkWithUtmParams } from '../../../utils/campaignUtils';

export default class BaseStaticPage extends Component {

    styles = styles;
    content_json_key = '##your content json key here##';
    containerRef = React.createRef();
    headerActions = undefined;
    footerLinks = undefined;

    parseJsonString = () => {
        try {
            const data = JSON.parse(guc(this.content_json_key));
            return isEmptyObject(data) ? { isValid: false } : { isValid: true, data };
        } catch (_) {
            console.log(`Error parsing ${this.content_json_key}`);
            return { isValid: false };
        }
    }

    state = this.parseJsonString();

    onScroll = e => this.setState({ scrollPos: e.currentTarget.scrollTop });

    componentDidMount = () => {
        if (this.state.isValid) logPageView();
        else this.props.history.replace('/');
    }

    renderHeader = () => <SimpleHeader actions={this.headerActions} />;

    renderImageContent = () => {
        const { leftText, rightText } = this.state.data;
        return <>
            <div style={this.gs('left_card')}>
                <div style={this.gs('left_card_heading')}>{Parser(leftText)}</div>
            </div>
            <div style={this.gs('card_divider')} />
            <div style={this.gs('right_card')}>
                <div>{Parser(rightText)}</div>
            </div>
        </>;
    }

    renderImage = () => {
        const { image } = this.state.data;
        return <div style={this.gs('image_containter')}>
            <img style={this.gs('image')} src={image} />
            {this.renderImageContent()}
        </div>;
    }

    renderContent = () => null;

    scrollToTop = () => this.containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });

    renderGoToTopButton = () => <Grow in={this.state.scrollPos > 200}><div style={this.gs('go_to_top')} onClick={this.scrollToTop}>
        <VerticalAlignTopRounded style={{ fontSize: 18, marginRight: 8 }} />{guc('back_to_top', 'Back to top')}
    </div></Grow>;

    renderFooter = () => <Footer links={this.footerLinks} />;
    
    renderCarousel = () => {
        const { carousels } = this.state.data;
        if (isEmptyList(carousels)) return null;
        
        return <Carousel showArrows showStatus={false} stopOnHover={false} autoPlay infiniteLoop interval={5000}>
            {carousels.map(({ image, text, text_style, cta_text, cta_link }, i) => <div key={i} style={merge(this.gs('carousel_item'), { backgroundImage: `url(${image})` })}>
                <div style={merge(this.gs('carousel_text'), text_style)}>
                    {Parser(text)} <br />
                    {notIsEmptyString(cta_text) && <a href={getCtaLinkWithUtmParams(cta_link)} target='_blank'>
                        <ButtonBase style={this.gs('cta_button')}>{cta_text}</ButtonBase>
                    </a>}
                </div>
            </div>)}
        </Carousel>;
    }
    
    render = () => {
        if (!this.state.isValid) return null;
        return <div style={this.gs('container')} ref={this.containerRef} onScroll={this.onScroll}>
            {this.renderHeader()}
            {this.renderImage()}
            {this.renderContent()}
            {this.renderCarousel()}
            {this.renderGoToTopButton()}
            {this.renderFooter()}
        </div>;
    }

}
